// stores/banners/bannersStore.js
import { defineStore } from 'pinia';
import { api } from '../../services/api';
import config from '../../config';


const API_BASE_URL = config.apiUrl;


export const useBannersStore = defineStore('banner', {
  state: () => ({
    banners: {
      desktop: {
        regular: [],
        promo: null
      },
      mobile: {
        regular: [],
        promo: null
      },
      mini: {
        regular: [],
        promo: null
      },
      news: {
        active: false,
        message: null
      }
    },
    isLoading: false
  }),

  getters: {
    getActiveBanners: (state) => {
      const processImageUrl = (banner) => {
        if (!banner) return null;
        return {
          ...banner,
          image: banner.image.startsWith('http')
            ? banner.image
            : `${API_BASE_URL}${banner.image}`
        };
      };

      return {
        desktop: {
          regular: state.banners.desktop.regular
            .filter(banner => banner?.active)
            .map(processImageUrl),
          promo: state.banners.desktop.promo && state.banners.desktop.promo.active
            ? processImageUrl(state.banners.desktop.promo)
            : null
        },
        mobile: {
          regular: state.banners.mobile.regular
            .filter(banner => banner?.active)
            .map(processImageUrl),
          promo: state.banners.mobile.promo && state.banners.mobile.promo.active
            ? processImageUrl(state.banners.mobile.promo)
            : null
        },
        mini: {
          regular: state.banners.mini.regular
            .filter(banner => banner?.active)
            .map(processImageUrl),
          promo: state.banners.mini.promo && state.banners.mini.promo.active
            ? processImageUrl(state.banners.mini.promo)
            : null
        }
      };
    }
  },

  actions: {
    async initializeBanners() {
      try {
        this.isLoading = true;
        const response = await api.get('/banners');
        
        if (response.data.banners) {
          this.banners = response.data.banners;
        }
      } catch (error) {
        console.error('Error loading banners:', error);
      } finally {
        this.isLoading = false;
      }
    },

    updateBannersFromSocket(banners) {
      this.banners = banners;
    }
  }
});